module.exports = __webpack_public_path__ + "img/10.c86271b2.png";